<template>
<div :class="container">
  <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
  <div v-else-if="products.length == 0" class="text-center">No products</div>
  <div v-else>
  <div class="text-center pt-0 pb-2" v-if="totalProducts > 0">{{totalProducts}} {{ totalProducts === 1 ? 'product' : 'products' }}</div>
  <div class="row py-2 px-2">
      <div class="col-md-3 px-3 col-6 p-0 px-md-2 mb-3" v-for="(product, index) in products" :key="index">
          
          <a v-if="product.images" :href="`/product/${product.id}/${createSlug(product.name)}`" class="cardlink">
            <div class="card video w-100 py-3 px-3 text-center">
                <div class="mb-1">
                    <img v-if="product.images.length > 0" class="video-thumbnail" :src="product.images[0].url" />
                    <img v-else class="video-thumbnail" src="/images/image-not-found.svg" />
                </div>
                <h4 class="video-list-name mt-1">{{product.name}}</h4>
                <small v-if="product.seller" class="blue">{{product.seller.business_name}}</small>
                <div class="mt-2 price">R {{product.price}}</div>
            </div>
          </a>

      </div>
  </div>
</div>
</div>
</template>

<script>
export default {
props : ['category_id', 'container', 'product_id', 'page'],

  data() {
    return {
      products: [],
      totalProducts: 0,
      loading: false,
    };
  },

  created() {
    this.getProducts();

    // Echo.channel("products")
    //   .listen("NewProduct", (event) => {
    //     if (this.category_id == 0) {
    //       this.getProducts();
    //     }
    //   });
  },

  methods: {

    getProducts() {

      // if category_id = 'continue' then get products from local storage
      if(this.category_id == 'continue') {
        if(localStorage.getItem('history')) {
          this.products = JSON.parse(localStorage.getItem('history'));
        }
        return;
      }

      this.loading = true;

      axios
        .post('/product/list', {category_id: this.category_id, product_id: this.product_id})
        .then((response) => {
          this.products = response.data;
          this.loading = false;

          // set total products
          if(this.page == 'search' || this.page == 'category') {
            this.totalProducts = response.data.length;
          }
        });
    },

  },
};
</script> 
